import styles from './styles.module.css';

type Props = {
  text: string;
};

export const ErrorLabel = ({ text }: Props) => {
  return <div className={styles.error}>{text}</div>;
};
